import React from 'react';
import styles from '../CustomDetails.module.scss';

export default function ChoiceHintText() {
  return <span className={styles.choice_hint_text}>This option cause ticket creation</span>;
}
